// extracted by mini-css-extract-plugin
export default {"socialMediaItemContainer":"SocialMediaCard_socialMediaItemContainer__FMf4-"};